module.exports = __webpack_public_path__ + "img/fashion-spec_0.cbd74071.jpg";